// @ts-expect-error needs fixing in upstream lib
import { waitForServicesLibrary } from '@boschrexroth/dc.ncj.frontend-services-npm/dist/static-lib.js';
import { defineCustomElements } from '@boschrexroth/nextgen-web-ui-toolkit/loader';

export default async function () {
    defineCustomElements();
    return waitForServicesLibrary();
}
